<template>
  <div class="overlay2">
    <div class="overlay back"></div>
    <div class="masthead">
      <div class="masthead-bg"></div>
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-12 my-auto">
            <div class="masthead-content text-white py-5 py-md-0">
              <h2 class="mb-3">
                <font style="vertical-align: inherit;">
                  <font style="vertical-align: inherit;"></font>
                  Portal de Afiliación a Partidos Políticos constituidos <span v-if="isDevelopment">- Entorno de desarrollo</span>
                </font>
              </h2>
              <router-link class="btn-cu btn-claveunica" :to="{ name: 'login' }">
                <span class="cl-claveunica"></span>
                <span class="texto">Iniciar sesión</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="social-icons">
      <img src="/img/logo0.png" style="max-height:100px"/>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import '@/assets/css/coming-soon.css';
import '@/assets/css/cu.css';

export default {
  data() {
    return {
      isDevelopment: false
    }
  },
  beforeMount() {
    this.isDevelopment = typeof process.env.VUE_APP_ORIGIN !== 'undefined' ?
      process.env.VUE_APP_ORIGIN.normalize() === 'dev'.normalize() : false
  },
  mounted() {
    store.dispatch('setInitApp', false)

    // eliminar todo de local storage
    localStorage.clear()
  }
}
</script>
<style scoped>


.back {
  background-image: url(../../public/img/backgrond.jpg);
  background-size: cover;
  background-position: bottom;
}

.overlay2 {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1;
}
</style>
